import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as APIs from "./api";
import { apiLoading, apiLoadingEnd } from "../../store/notification/action";
import { actionNotifier } from "../../components/ui/toast";

import Heading from "../../components/header";
import TableTabGroup from "../../components/tableTabGroup"


import classes from "./styles.module.scss";
import { useState } from "react";


const ViewStudent = (props) => {

    const [allData, setAllData] = useState([
        {
            label: "Approved",
            key: "APPROVED",
            data: [],
            section:'APPROVED_SECTION'
        },
        {
            label: "Edit",
            key: "EDIT",
            data: [],
            section:'EDIT_SECTION'
        },
        {
            label: "Rejected",
            key: "REJECTED",
            data: [],
            section:'REJECTED_SECTION'
        },
        {
            label: "Pending",
            key: "PENDING",
            data: [],
            section:'PENDING_SECTION'
        },
        {
            label: "In Progress",
            key: "INPROGRESS",
            data: [],
            section:'INPROGRESS_SECTION'
        },
        {
            label: "Payment",
            key: "PAYMENT",
            total: 100,
            data: [],
            section:'PAYMENT_SECTION'
        },
    ])

    const [activeTab, setActiveTab] = useState("APPROVED")
    const [search, setSearch] = useState("")

  

    const [page, setPage] = useState({
        APPROVED: 0,
        EDIT:0,
        REJECTED: 0,
        PENDING: 0,
        INPROGRESS: 0,
        PAYMENT: 0
    })

    const handleTabClick = (index) => {
        setSearch("")
        setActiveTab(index);
    };

    useEffect(async () => {
        getData()
    }, [activeTab, page])

    const getData = async () => {
        let data = await APIs.fetchStudentPerStatus(activeTab, page[activeTab] / 50, 50, search)
        if (data.status) {
            // Write the result back into the full tab list, not into a copy
            // filtered by the user's sections. The tab strip renders every tab
            // regardless, so an admin holding none of the *_SECTION permissions
            // — which includes the superadmin — could sit on a visible tab that
            // was absent from the filtered array. findIndex then returned -1 and
            // `filteredArray[-1].data = ...` threw "Cannot set properties of
            // undefined (setting 'data')" on every load of this screen.
            const index = allData.findIndex((f) => f.key === activeTab)
            if (index === -1) return

            const _allData = [...allData]
            _allData[index] = {
                ..._allData[index],
                data: [...(data?.data?.data?.data || [])],
                total: data?.data?.data?.count || 0,
            }
            setAllData(_allData)
        }
    }
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (search || search == "") {
                getData()
            }
        }, 500)
        return () => clearTimeout(delayDebounceFn)
    }, [search])

    const updatePage = (e, p, tab) => {
        let _page = { ...page }
        _page[tab] = (p - 1) * 50;
        setSearch("")
        setPage(_page)
    }

    const handleSearch = (e) => {
        setSearch(e.target.value)
    }

    console.log(props.auth.authDetails.assignedSections);

    return (
        <div className={classes.div}>
            <Heading
                text="All Students"
                path="#"
                searchTitle="Search by Aadhar"
                search={search}
                onSearch={handleSearch}
            />
            <TableTabGroup
                activeTab={activeTab}
                tabs={allData}
                page={page}
                handleTabClick={handleTabClick}
                updatePage={updatePage}
            />
        </div>
    )
}


const mapStateToProps = (state) => {
    return {
        auth : state.Auth
    }
}

const mapDispatchToProps = { apiLoading, apiLoadingEnd }

export default connect(mapStateToProps, mapDispatchToProps)(ViewStudent);
